'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module2Act1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, profile: state.profile.data, app: state.moduleData.data.module2.act1 };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Act1, _Component);

  function Module2Act1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Act1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Act1.__proto__ || (0, _getPrototypeOf2.default)(Module2Act1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Accessibility of fruit and vegetables',
      moduleId: 2,
      appId: 1,
      isCompleted: false,
      firstAct: _this.props.app.firstAct || '',
      secondAct: _this.props.app.secondAct || '',
      vegiesCut: _this.props.app.vegiesCut || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);

      _this.props.changeItem(_this.state.moduleId, 2, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  (0, _createClass3.default)(Module2Act1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'As activities for this week, we have a few options. Both are aimed at preparing fruits and vegies so they are easy for kids to eat as snacks.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Activity 1'
          ),
          _react2.default.createElement(
            'p',
            null,
            'The first is a fun family activity using the fridge that helps kids identify what fresh, cut up fruit and vegetables are in your fridge at home. In your pack, you should have received magnets with fruit and vegtables and a picture of a fruit bowl. The idea of this activity is to let your family know what is available in the fridge that week by placing the magnet for the fruit and vegetables that are in the fridge in the magnetic bowl that sits on the fridge.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If you have a rule about not taking food without asking that\'s ok. Let the family know that they can ask for one of the items on the magnet if it is an appropriate snack time.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If you don\'t think this will work well for you, you can always tell your family so they know what is available.'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Is this something you would like to try this week?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleChange.bind(this, 'firstAct') },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'firstAct', value: YES, checked: this.state.firstAct === YES },
              YES
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'firstAct', value: NO, checked: this.state.firstAct === NO },
              NO
            )
          ),
          this.state.firstAct === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Great, we will add this in your strategies table under \'My goals\'!'
            )
          ),
          this.state.firstAct && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              null,
              'Activity 2'
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Would you like to plan some times to chop up vegies to keep in the fridge for ',
              this.props.profile.childname,
              ' for this week?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChange.bind(this, 'secondAct') },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'secondAct', value: YES, checked: this.state.secondAct === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'secondAct', value: NO, checked: this.state.secondAct === NO },
                NO
              )
            )
          ),
          this.state.secondAct === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Great, what sort of vegies will you cut up?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              null,
              _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Eg. Vegies - celery, carrot, capsicum sticks,\\ cherry tomatoes cut in half',
                value: this.state.vegiesCut, onChange: this.handleChange.bind(this, 'vegiesCut') })
            ),
            _react2.default.createElement(
              'p',
              null,
              'Remember to: wash first, then chop into child-friendly pieces, store in an air-tight container.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This will be recorded in the activities column of your goals in \'My goals\'.'
            )
          ),
          this.state.secondAct === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok, maybe another time.'
            )
          ),
          this.state.vegiesCut && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module2Act1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModuleAct: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module2Act1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Activities/Act1.js
// module id = 1178
// module chunks = 0